// src/components/Layout.js
import React from "react";
import Header from "./Header";
import Footer from "./Footer"; // ✅ Import the Footer

export default function Layout({ children, wallet, connectWallet }) {
  return (
    <div className="bg-[#0f0c29] min-h-screen text-white flex flex-col">
      <Header wallet={wallet} connectWallet={connectWallet} />
      
      {/* Main content */}
      <main className="flex-grow w-full px-10 py-10">
        {children}
      </main>

      {/* ✅ Global Footer */}
      <Footer />
    </div>
  );
}
